import { z } from 'zod'

export const EventType = z.enum([
  'document.uploaded',
  'document.received',
  'document.identified',
  'document.metadata_updated',
  'document.reassigned',
  'document.routing_evaluated',
  'document.routing_skipped',
  'document.routed',
  // Recatalogação material (fecho do !300): uma re-identificação que mudou um campo fiscal ou o
  // cliente. Payload: {source, fields[], material} — nomes de campos apenas, nunca valores. Os
  // portões de envio aceitam-no como carve-out quando é mais novo que o último envio.
  'document.recatalogued',
  // O irmão de observação: escrito em modo observe, lido por NENHUM portão — métrica durável do
  // que o modo live teria feito. A separação é deliberada: estampar o evento real em observe
  // seria, por si só, libertar o cohort entregue que está identified+claim-limpo.
  'document.recatalogue_observed',
  'document.validated',
  'document.reconciled',
  'document.error',
  'client_config.edited',
  'user.login',
  'user.mfa_challenge',
  'user.invited',
  'pipeline.submission',
  // Analytical-tags rules engine (poller tag-rules tick). Payloads carry
  // uuids/booleans/numbers only — tag and dimension NAMES are client vocabulary
  // and stay out of event payloads (redaction red line).
  'document.tag_rule_applied',
  'document.tag_rule_conflict',
  'document.tag_rules_failed',
  'document.tags_updated',
])
export type EventType = z.infer<typeof EventType>

export const Event = z.object({
  id: z.string().uuid(),
  type: EventType,
  actorId: z.string().uuid().nullable(),
  subjectType: z.enum(['document', 'client', 'user', 'pipeline']),
  subjectId: z.string(),
  payload: z.record(z.unknown()),
  occurredAt: z.string().datetime(),
})
export type Event = z.infer<typeof Event>
